import { Injectable } from '@angular/core';


@Injectable()
export class ColorRange {

	private readonly COLOR_RANGE: string[] = [
		"#EBBA16",
		"#E13628",
		"#634B81",
		"#349886",
		"#09ADDF",
		"#983473",
		"#F57C00",
		"#7683D8",
		"#DE3765"
	];

	constructor() {
	}

	public assignColors( keys: string[] ): Object {
		let colors: Object = null;
		if( keys && keys.length > 0 ) {
			colors = {};
			let nextColorIndex: number = 0;
			keys.forEach( key => {
				colors[ key ] = this.COLOR_RANGE[ nextColorIndex ];
				nextColorIndex = ++nextColorIndex % this.COLOR_RANGE.length;
			});
		}
		return colors;
	}

}